import type { ColumnDef } from '@benzinga/table';
import type { TopInsiderCompany } from '@benzinga/insider-trades-manager';
import { formatLarge } from '@benzinga/utils';
import { TickerCell, NetVolumeCell } from './index';

export function getNetVolumeColumnDefs(): ColumnDef<TopInsiderCompany>[] {
  return [
    {
      field: 'company_ticker',
      headerName: 'Ticker',
      width: 140,
      cellRenderer: (params: { data: TopInsiderCompany }) => {
        const row = params.data;
        if (!row) return null;
        return (
          <TickerCell cik={row.company_cik ?? ''} ticker={row.company_ticker ?? ''} name={row.company_name ?? ''} />
        );
      },
    },
    {
      field: 'filings_count',
      headerName: 'Filing Count',
      width: 110,
      valueFormatter: ({ value }: { value: number | undefined }) => (value != null ? value.toLocaleString() : '—'),
    },
    {
      field: 'buy_shares',
      headerName: 'Shares (Buy)',
      width: 110,
      valueFormatter: ({ value }: { value: number | undefined }) => (value != null ? value.toLocaleString() : '—'),
    },
    {
      field: 'sell_shares',
      headerName: 'Shares (Sell)',
      width: 110,
      valueFormatter: ({ value }: { value: number | undefined }) => (value != null ? value.toLocaleString() : '—'),
    },
    {
      field: 'net_shares',
      headerName: 'Shares (Net)',
      width: 110,
      cellRenderer: ({ value }: { value: number | undefined }) => {
        if (value == null) return '-';
        const isPositive = value >= 0;
        return (
          <span className={`stat-value ${isPositive ? 'positive' : 'negative'}`}>
            {!isPositive ? '-' : ''}
            {formatLarge(Math.abs(value))}
          </span>
        );
      },
    },
    {
      field: 'buy_volume',
      headerName: 'Buy Volume',
      width: 110,
      valueFormatter: ({ value }: { value: number | undefined }) => (value != null ? '$' + formatLarge(value) : '—'),
    },
    {
      field: 'sell_volume',
      headerName: 'Sell Volume',
      width: 110,
      valueFormatter: ({ value }: { value: number | undefined }) => (value != null ? '$' + formatLarge(value) : '—'),
    },
    {
      field: 'total_volume',
      headerName: 'Total Volume',
      width: 120,
      valueFormatter: ({ value }: { value: number | undefined }) => (value != null ? '$' + formatLarge(value) : '—'),
    },
    {
      field: 'net_volume',
      headerName: 'Volume (Net)',
      width: 120,
      cellRenderer: ({ value }: { value: number | undefined }) => {
        if (value == null) return '-';
        const val = Number(value);
        const isPositive = value >= 0;
        return <NetVolumeCell value={val} isPositive={isPositive} />;
      },
    },
  ];
}
